import { api } from "./api";

export const getVersionAppRequest = (payload) => api.get(`/VersionGardi`, payload);
export const setVersionAppRequest = (payload) => api.post(`/SetVersionGardi?version=${payload.version}`);

// corporativo
export const getVersionAppCorpRequest = (payload) => api.get(`/Version/GetVersion`, payload, true);